// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store';
import '@/permission';
import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false;
Vue.use(Element);
Vue.use(BaiduMap, { ak: 'iBM9rbzTH2dMZW7MbYMYmFgb' })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js